import { forwardRef, useMemo } from 'react';
import ReactNodeViewPortalsProvider from './utils/ReactNodeViewPortals';

// @ts-expect-error no types
import SharedDragDropContext from 'customer-data-ui-utilities/dnd/SharedDragDropContext';
import { WithDropTarget } from './ProsemirrorDnd';
import { Prosemirror } from './Prosemirror';
import { EditorStateContext } from './contexts/EditorStateContext';
import useDebounce from './utils/useDebounce';
import { jsx as _jsx } from "react/jsx-runtime";
export let InstanceKey;
export const ProsemirrorEditor = Prosemirror;
const NodeViewWrapper = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    editorState,
    setEditorState
  } = props;
  const memoizedEditorState = useMemo(() => {
    return {
      editorState,
      setEditorState
    };
  }, [editorState, setEditorState]);
  const debouncedEditorState = useDebounce(memoizedEditorState, 50);
  return /*#__PURE__*/_jsx(EditorStateContext.Provider, {
    value: debouncedEditorState,
    children: /*#__PURE__*/_jsx(ReactNodeViewPortalsProvider, {
      children: /*#__PURE__*/_jsx(Prosemirror, Object.assign({}, props, {
        DropTargetWrapper: WithDropTarget,
        DragDropContext: SharedDragDropContext,
        ref: ref
      }))
    })
  });
});
export default NodeViewWrapper;